import {createSlice} from "@reduxjs/toolkit";
import {addComponent, saveComponent} from "../pageComponents/componentsThunks";
import {
    addBannerSlide,
    deleteBannerSlide,
    fetchCategories,
    fetchTags,
    updateBannerSlide
} from "./selectedComponentThunks";
import {saveAppbar, saveDrawer, saveNavbar} from "../globalComponents/globalComponentsThunks";
import {activateSupportPlugin} from "../config/configThunks";

const selectedComponentSlice = createSlice({
    name: 'selectedComponent',
    initialState: {
        selectedComponent: null,
        copySelectedComponent: null,
        isDirty: false, // Track if the copy has been modified
        isSaved: false, // Track if the copy has been saved
        loading: false,
        categories: [],
        tags: [],
    },
    reducers: {
        setIsDirty: (state, action) => {
            state.isDirty = action.payload;
        },
        setSelectedComponent: (state, action) => {
            state.selectedComponent = action.payload;
            state.copySelectedComponent = action.payload;

        },
        updateCopySelectedComponentProperty: (state, action) => {
            if (state.copySelectedComponent) {
                state.copySelectedComponent = {
                    ...state.copySelectedComponent,
                    ...action.payload

                };
                state.isDirty = true; // Mark as dirty when copy is updated
            }

        },
        updateCopySelectedComponentStyles: (state, action) => {
            if (state.copySelectedComponent) {
                state.copySelectedComponent = {
                    ...state.copySelectedComponent,
                    customize_styles: {
                        ...state.copySelectedComponent.customize_styles,
                        [action.payload.styleGroup]: {
                            ...state.copySelectedComponent.customize_styles[action.payload.styleGroup],
                            [action.payload.key]: action.payload.value,
                        }
                    },
                };
                state.isDirty = true; // Mark as dirty when copy is updated
            }

        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addComponent.fulfilled, (state, action) => {
                state.selectedComponent = action.payload;
                state.copySelectedComponent = action.payload;
            })

            .addCase(saveComponent.pending, (state) => {
                state.isSaved = true;
            })
            .addCase(saveComponent.fulfilled, (state, action) => {
                state.isSaved = false;
                state.selectedComponent = state.copySelectedComponent;
            })




            .addCase(saveAppbar.fulfilled, (state, action) => {
                state.selectedComponent = state.copySelectedComponent;
            })


            .addCase(saveNavbar.fulfilled, (state, action) => {
                state.selectedComponent = state.copySelectedComponent;
            })


            .addCase(saveDrawer.fulfilled, (state, action) => {
                state.selectedComponent = state.copySelectedComponent;
            })



            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.categories = [];
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
            })



            .addCase(fetchTags.pending, (state) => {
                state.loading = true;
                state.tags = [];
            })
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.loading = false;
                state.tags = action.payload;
            })



            .addCase(addBannerSlide.fulfilled, (state, action) => {
                state.selectedComponent = {
                    ...state.selectedComponent,
                    customize_properties: {
                        ...state.selectedComponent.customize_properties,
                        items: [
                            ...state.selectedComponent.customize_properties.items,
                            action.payload
                        ]
                    }
                };

                state.copySelectedComponent = {
                    ...state.copySelectedComponent,
                    customize_properties: {
                        ...state.copySelectedComponent.customize_properties,
                        items: [
                            ...state.copySelectedComponent.customize_properties.items,
                            action.payload
                        ]
                    }
                };
            })

            .addCase(deleteBannerSlide.fulfilled, (state, action) => {
                state.selectedComponent = {
                    ...state.selectedComponent,
                    customize_properties: {
                        ...state.selectedComponent.customize_properties,
                        items: action.payload
                    }
                };

                state.copySelectedComponent = {
                    ...state.copySelectedComponent,
                    customize_properties: {
                        ...state.copySelectedComponent.customize_properties,
                        items: action.payload
                    }
                };
            })


            .addCase(updateBannerSlide.fulfilled, (state, action) => {

                const updatedItems = state.selectedComponent.customize_properties.items.map(item =>
                    item.id === action.payload.id ? action.payload : item
                );

                state.selectedComponent = {
                    ...state.selectedComponent,
                    customize_properties: {
                        ...state.selectedComponent.customize_properties,
                        items: updatedItems
                    }
                };

                state.copySelectedComponent = {
                    ...state.copySelectedComponent,
                    customize_properties: {
                        ...state.copySelectedComponent.customize_properties,
                        items: updatedItems
                    }
                };
            })


            .addCase(activateSupportPlugin.fulfilled, (state, action) => {
                state.selectedComponent = null; // Reset selected component on plugin activation
                state.copySelectedComponent = null; // Reset copy on plugin activation
                state.isDirty = false; // Reset dirty state
                state.isSaved = false; // Reset saved state
            })
    }
});

export const {setIsDirty, setSelectedComponent, updateCopySelectedComponentProperty, updateCopySelectedComponentStyles} = selectedComponentSlice.actions;
export default selectedComponentSlice.reducer;